// extracted by mini-css-extract-plugin
export default {"root":"ParticipantList_root__X7R5Z","list":"ParticipantList_list__DngFM"};